// extracted by mini-css-extract-plugin
export var lg = "_l9-7";
export var md = "_l9-6";
export var placeholderContainer = "_l9-1";
export var placeholderIcon = "_l9-2";
export var productImage = "_l9-0";
export var sm = "_l9-5";
export var xl = "_l9-8";
export var xs = "_l9-4";
export var xxs = "_l9-3";